// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MgO_n","heroCarousel":"styles_heroCarousel__sVfXf","paginationWrapper":"styles_paginationWrapper__NgX_K"};